import { z } from 'zod'
export const communityTag = z.string().trim().toLowerCase().regex(/^[a-z0-9][a-z0-9-]{0,39}$/)
export const communityTags = z.array(communityTag).max(8).transform(tags=>[...new Set(tags)].sort())
export function parseCommunityTags(value:string){return communityTags.parse(value.split(',').map(tag=>tag.trim()).filter(Boolean))}
